import { Controller } from "@hotwired/stimulus";
import { StatsigClient } from "@statsig/js-client";
import { StatsigSessionReplayPlugin } from "@statsig/session-replay";
import { StatsigAutoCapturePlugin } from "@statsig/web-analytics";

let statsigClient = null;
let statsigInitialized = false;

// Connects to data-controller="statsig"
export default class extends Controller {
  static values = {
    sdkKey: String,
    userId: String,
    userEmail: String,
  };

  async connect() {
    if (!this.sdkKeyValue) {
      console.warn("Statsig SDK key not provided");
      return;
    }

    if (this.#getEnvironment() === "development") {
      return;
    }

    if (statsigInitialized) {
      return;
    }

    const environment = this.#getEnvironment();
    try {
      const plugins = [];

      // Only enable session replay in production
      if (environment === "production") {
        plugins.push(new StatsigSessionReplayPlugin());
        plugins.push(new StatsigAutoCapturePlugin());
      }

      statsigClient = new StatsigClient(
        this.sdkKeyValue,
        this.hasUserIdValue
          ? {
              userID: this.userIdValue,
              email: this.hasUserEmailValue ? this.userEmailValue : undefined,
            }
          : undefined,
        {
          environment: { tier: environment },
          plugins: plugins,
        },
      );

      await statsigClient.initializeAsync();

      statsigInitialized = true;
    } catch (error) {
      if (environment !== "production") {
        console.error("Failed to initialize Statsig:", error);
      }
    }
  }

  #getEnvironment() {
    const meta = document.head.querySelector("meta[name=environment]");
    return meta ? meta.content : "production";
  }
}
